import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async get(id: number) {
    return wrapEndpoint(() =>
      client.GET('/extension/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async getByName(name: string) {
    return wrapEndpoint(() =>
      client.GET('/extension/by-name/{name}', {
        params: {
          path: {
            name,
          },
        },
      }),
    )
  },
  async getSubscription(id: number) {
    return wrapEndpoint(() =>
      client.GET('/extension/{id}/subscription', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async list(options?: ApiSchemas['ListExtensionDto']) {
    return wrapEndpoint(() =>
      client.GET('/extension', {
        params: {
          query: options,
        },
      }),
    )
  },
  async subscribe(id: number, body: ApiSchemas['SubscribeToExtensionDto']) {
    return wrapEndpoint(() =>
      client.PATCH('/extension/{id}/subscribe', {
        params: {
          path: {
            id,
          },
        },
        body,
      }),
    )
  },
  async unsubscribe(id: number) {
    return wrapEndpoint(() =>
      client.PATCH('/extension/{id}/unsubscribe', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async subscribeAsAdmin(id: number, physicianId: number, body: ApiSchemas['SubscribeToExtensionDto']) {
    return wrapEndpoint(() =>
      client.PATCH('/extension/{id}/subscribe/{physicianId}', {
        params: {
          path: {
            id,
            physicianId,
          },
        },
        body,
      }),
    )
  },
  async unsubscribeAsAdmin(id: number, physicianId: number) {
    return wrapEndpoint(() =>
      client.PATCH('/extension/{id}/unsubscribe/{physicianId}', {
        params: {
          path: {
            id,
            physicianId,
          },
        },
      }),
    )
  },
  async updateSubscriptionAsAdmin(id: number, physicianId: number, body: ApiSchemas['SubscribeToExtensionDto']) {
    return wrapEndpoint(() =>
      client.PATCH('/extension/{id}/update-diseases/{physicianId}', {
        params: {
          path: {
            id,
            physicianId,
          },
        },
        body,
      }),
    )
  },
}
